import { render, staticRenderFns } from "./SvpOccupationalFactors.vue?vue&type=template&id=e453c1d2&scoped=true"
import script from "./SvpOccupationalFactors.vue?vue&type=script&lang=js"
export * from "./SvpOccupationalFactors.vue?vue&type=script&lang=js"
import style0 from "./SvpOccupationalFactors.vue?vue&type=style&index=0&id=e453c1d2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e453c1d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e453c1d2')) {
      api.createRecord('e453c1d2', component.options)
    } else {
      api.reload('e453c1d2', component.options)
    }
    module.hot.accept("./SvpOccupationalFactors.vue?vue&type=template&id=e453c1d2&scoped=true", function () {
      api.rerender('e453c1d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/seven/components/SvpOccupationalFactors.vue"
export default component.exports